// @flow
import isEqual from "lodash.isequal";
import isEmpty from "lodash.isempty";

const normalizeFilters = (filters: Object, initialFilters: Object) => {
  const normalizedFilters = { ...filters };

  Object.entries(normalizedFilters).forEach(([filterKey, filterValue]) => {
    if (Array.isArray(filterValue)) {
      if (isEmpty(filterValue) || isEqual(filterValue, initialFilters[filterKey])) {
        delete normalizedFilters[filterKey];
      }
    } else if (filterValue && typeof filterValue === "object") {
      if ((filterValue.start == null && filterValue.end == null) || isEqual(filterValue, initialFilters[filterKey])) {
        delete normalizedFilters[filterKey];
      }
    }
  });

  return normalizedFilters;
};

export default normalizeFilters;
